import React, { useMemo } from 'react';
import './DesktopStrategyField.css';

const RING_COLORS = ['#A78BFA', '#60A5FA', '#5EEAD4', '#4ADE80', '#F472B6'];

function initialsFor(name) {
  return name
    .split(' ')
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

// Strategy Mode - field view. Lays out every donor as a ring in a grid, no
// scoring or path-finding yet - just the visual foundation for the rest of
// Strategy Mode to build on.
function DesktopStrategyField({ donors }) {
  const people = useMemo(() => {
    return Object.keys(donors || {}).map((name, i) => ({
      name,
      initials: initialsFor(name),
      ring: RING_COLORS[i % RING_COLORS.length]
    }));
  }, [donors]);

  return (
    <div className="strategy-field">
      <div className="strategy-stats">
        <div className="strategy-stat">
          <p className="strategy-stat-label">People</p>
          <p className="strategy-stat-value">{people.length}</p>
        </div>
        <div className="strategy-stat">
          <p className="strategy-stat-label">In this path</p>
          <p className="strategy-stat-value dim">—</p>
        </div>
        <div className="strategy-stat">
          <p className="strategy-stat-label">Target</p>
          <p className="strategy-stat-value dim">—</p>
        </div>
      </div>

      <div className="strategy-field-head">
        <h1>People</h1>
        <p>Everyone you know. Describe a campaign to chart a path through them.</p>
      </div>

      {people.length === 0 ? (
        <div className="strategy-field-empty">
          <p>Add donors in Knowroom to see them here</p>
        </div>
      ) : (
        <div className="strategy-grid">
          {people.map(person => (
            <div
              key={person.name}
              className="strategy-ring"
              style={{ '--ring-color': person.ring }}
              title={person.name}
            >
              <span>{person.initials}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DesktopStrategyField;
